"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isArrayOfType = void 0;
const is_array_1 = require("./is-array");
exports.isArrayOfType = (value, type) => is_array_1.isArray(value) && value.every((element) => typeof element === type);
//# sourceMappingURL=is-array-of-type.js.map